import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export async function revokeIntegration() {
  await usersApi.post(apiRoutes.revokeIntegration('john-deere'))
}
